export default __webpack_public_path__ + "static/media/mentalHealth.5cc0df21.svg";